import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Spinner } from '../../common/components';

const Schools = ({ location }) => {
  const adminRelationships = useSelector(state => state.admin.adminRelationships);

  if (adminRelationships?.data === null) {
    return <Spinner />;
  }

  return (
    <Redirect
      to={{
        pathname: `/schools/${adminRelationships?.data?.org?.id}`,
        state: { from: location.pathname },
      }}
    />
  );
};

Schools.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default Schools;
